// @ts-nocheck
import {
    GAMING_ACTIVITY_FIRST_GROUP_DATA_CHANGED,
    GAMING_ACTIVITY_FIRST_GROUP_DATA_CLEARED,
    GAMING_ACTIVITY_FIRST_GROUP_EXPANDED_ROWS_CHANGED,
    GAMING_ACTIVITY_FIRST_GROUP_EXPANDED_ROWS_CLEARED,
    GAMING_ACTIVITY_SECOND_GROUP_DATA_CHANGED,
    GAMING_ACTIVITY_SECOND_GROUP_DATA_CLEARED,
    GAMING_ACTIVITY_SECOND_GROUP_EXPANDED_ROWS_CHANGED,
    GAMING_ACTIVITY_SECOND_GROUP_EXPANDED_ROWS_CLEARED,
    GAMING_ACTIVITY_THIRD_GROUP_DATA_CHANGED,
    GAMING_ACTIVITY_THIRD_GROUP_DATA_CLEARED,
} from '../types';

const initialFirstGroupState = {
    reports: [],
    summary: {},
};

const initialState = {
    firstGroup: initialFirstGroupState,
    expandedFirstGroupRows: [],
    secondGroup: {},
    expandedSecondGroupRows: [],
    thirdGroup: {},
};

const gamingActivity = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case GAMING_ACTIVITY_FIRST_GROUP_DATA_CHANGED: {
            return {
                ...state,
                firstGroup: {
                    ...state.firstGroup,
                    ...payload,
                },
            };
        }
        case GAMING_ACTIVITY_FIRST_GROUP_DATA_CLEARED: {
            return {
                ...state,
                firstGroup: initialFirstGroupState,
            };
        }
        case GAMING_ACTIVITY_SECOND_GROUP_DATA_CHANGED: {
            return {
                ...state,
                secondGroup: {
                    ...state.secondGroup,
                    [payload.firstGroupId]: { ...state.secondGroup[payload.firstGroupId], ...payload.data },
                },
            };
        }
        case GAMING_ACTIVITY_SECOND_GROUP_DATA_CLEARED: {
            return {
                ...state,
                secondGroup: {},
            };
        }
        case GAMING_ACTIVITY_THIRD_GROUP_DATA_CHANGED: {
            return {
                ...state,
                thirdGroup: {
                    ...state.thirdGroup,
                    [payload.secondGroupId]: { ...state.thirdGroup[payload.secondGroupId], ...payload.data },
                },
            };
        }
        case GAMING_ACTIVITY_THIRD_GROUP_DATA_CLEARED: {
            return {
                ...state,
                thirdGroup: {},
            };
        }
        case GAMING_ACTIVITY_FIRST_GROUP_EXPANDED_ROWS_CHANGED: {
            const found = state.expandedFirstGroupRows.includes(payload);
            const newExpandedRows = found
                ? state.expandedFirstGroupRows.filter(row => row !== payload)
                : state.expandedFirstGroupRows.concat(payload);

            return {
                ...state,
                expandedFirstGroupRows: newExpandedRows,
            };
        }
        case GAMING_ACTIVITY_FIRST_GROUP_EXPANDED_ROWS_CLEARED: {
            return {
                ...state,
                expandedFirstGroupRows: [],
            };
        }
        case GAMING_ACTIVITY_SECOND_GROUP_EXPANDED_ROWS_CHANGED: {
            const found = state.expandedSecondGroupRows.includes(payload);
            const newExpandedRows = found
                ? state.expandedSecondGroupRows.filter(row => row !== payload)
                : state.expandedSecondGroupRows.concat(payload);

            return {
                ...state,
                expandedSecondGroupRows: newExpandedRows,
            };
        }
        case GAMING_ACTIVITY_SECOND_GROUP_EXPANDED_ROWS_CLEARED: {
            return {
                ...state,
                expandedSecondGroupRows: [],
            };
        }
        default:
            return state;
    }
};

export default gamingActivity;
